module.exports = __webpack_public_path__ + "static/media/closing-eye-view-svgrepo-com.5d68652a.svg";